/**
 * Nhận ca HỘ thợ (QĐ 0439, CEO chốt 20/10/2026). Từ ca chụp 21/10/2026, thợ
 * chụp / thợ trang điểm chưa nhận ca thì ca đó không có lương; Trưởng cửa hàng
 * / Giám đốc nhận hộ người đã thật sự đi ca, bắt buộc ghi lý do.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api/client";
import { serverErrorMessage } from "@/lib/api/error-message";
import type { components } from "@/lib/api/generated/schema";

type EkipConfirmMap = components["schemas"]["EkipConfirmMap"];

export function useAcceptShiftOnBehalf(orderId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ staffId, reason }: { staffId: string; reason: string }) => {
      const { data, error } = await api.POST("/ekip/confirms/{orderId}/accept-on-behalf", {
        params: { path: { orderId } },
        body: { staffId, reason },
      });
      if (error || !data) throw new Error(serverErrorMessage(error, "Không nhận ca hộ được"));
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["ekip", "confirms", orderId] });
      void qc.invalidateQueries({ queryKey: ["payroll"] });
    },
  });
}

/** Dấu nhận ca của người này do quản lý nhận HỘ — null nếu không phải. */
export function ekipProxyStamp(
  confirms: EkipConfirmMap | undefined,
  staffId: string | null | undefined,
): { by: string; reason: string } | null {
  const st = confirms && staffId ? confirms[`${staffId}_accept`] : undefined;
  if (!st?.proxyBy) return null;
  return { by: st.proxyBy, reason: st.proxyReason ?? "" };
}
